<nz-card>
  <div class="card-body">
    <h3 class="nfl-form-label mb1" nz-typography>Map Required Fields</h3>
    <nz-spin [nzTip]="loadingText" [nzSpinning]="isLoading">
      <form [formGroup]="mappingForm">
        <nz-tabset [nzDestroyInactiveTabPane]="true">
          <nz-tab
            *ngFor="let tableGroup of tablesArray.controls; let i = index"
            [nzTitle]="tableGroup.get('table_name')?.value || 'Table ' + (i + 1)"
          >
            <ng-template nz-tab>
              <div [formArrayName]="'tables'">
                <div [formGroupName]="i">
                  <p class="nfl-form-label" nz-typography>Tag columns for identification and email</p>
                  <div class="table-content">
                    <nz-table
                      [nzBordered]="true"
                      [nzData]="getColumnsArray(i).controls"
                      [nzSize]="'middle'"
                      [nzShowPagination]="false"
                      [nzScroll]="{ y: tableScrollHeight }"
                      class="mt1"
                    >
                      <thead>
                        <tr>
                          <th>Column Name</th>
                          <th nzWidth="50%">Identifier Type</th>
                          <th>Description</th>
                        </tr>
                      </thead>
                      <tbody formArrayName="columns">
                        <tr *ngFor="let columnGroup of getColumnsArray(i).controls; let j = index" [formGroupName]="j">
                          <td>{{ columnGroup.get('name')?.value }}</td>
                          <td>
                            <nz-select
                              formControlName="identifier"
                              class="w100"
                              [nzOptions]="identifierOptions"
                            ></nz-select>
                          </td>
                          <td>
                            <nz-form-control [nzErrorTip]="descriptionErrorTemplate">
                              <input nz-input formControlName="description" appTrimFormInput />
                            </nz-form-control>
                            <ng-template #descriptionErrorTemplate let-control>
                              <div *ngIf="control?.errors?.['maxlength']">
                                Description cannot exceed
                                {{ control?.errors?.['maxlength'].requiredLength }} characters.
                              </div>
                              <div *ngIf="control?.errors?.['pattern']">
                                Description should have at least one alphabet.
                              </div>
                            </ng-template>
                          </td>
                        </tr>
                      </tbody>
                    </nz-table>
                  </div>
                </div>
              </div>
            </ng-template>
          </nz-tab>
        </nz-tabset>
        <div *ngIf="!validateForm()" class="validation-message mt1">
          <nz-alert nzType="info" nzMessage="Duplicate mapping detected. Each mapping must be unique." nzShowIcon>
          </nz-alert>
        </div>
        <div class="action-buttons">
          <button *ngIf="tableName" nz-button nzType="default" class="mt1 mr1" routerLink="/data-connection">
            Back
          </button>
          <button nz-button nzType="primary" class="mt1" [disabled]="!isFormValid" (click)="saveMapping()">Save</button>
        </div>
      </form>
    </nz-spin>
  </div>
</nz-card>
